import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const OtaYhteyttaPage = () => (
  <Layout>
    <SEO title="Ota yhteyttä | Devisioona United" />
  </Layout>
)

export default OtaYhteyttaPage
